module.exports = __webpack_public_path__ + "static/media/YM11_5.fec999e1.jpg";